import api from './interceptor'
import apiFulfillment from './interceptorFulfillment'
import apiEW from './interceptorEW'

// 联系人列表
export const getContactsList = params => {
  console.log('getContactsList-->', params)
  return apiFulfillment.get('/customerContactPerson/list', { params })
}

export const addContacts = params => {
  console.log('addContacts-->', params)
  return apiFulfillment.post('/customerContactPerson/add', params)
}

export const deleteContacts = params => {
  console.log('deleteContacts-->', params)
  return apiFulfillment.get('/customerContactPerson/delete', { params })
}

export const updateContacts = params => {
  console.log('updateContacts-->', params)
  return apiFulfillment.post('/customerContactPerson/edit', params)
}
// 修改默认状态
export const changeContacts = params => {
  console.log('changeContacts-->', params)
  return apiFulfillment.post('/customerContactPerson/edit', params)
}

// 我的卡券列表
export const getMyCouponCard = (data = {}) => {
  let params = {
    ...data,
    pageNo: 1,
    pageSize: 10000
  }
  return apiFulfillment.get('/customerRightCoupon/myCouponList', { params })
}
// 服务合约-卡券可使用经销商
export const getApplyDealerDetails = (params = {}) => {
  // return apiFulfillment.get('/customerRightCoupon/getApplyDealerDetails', { params })
  return apiFulfillment.get('/malllist/couponDealerList', { params })
}

// 确认页获取信息（拆单）
export const getConfirmOrderInfo = params => {
  return apiFulfillment.post('/order/getConfirmOrderInfo', params)
}
// otr扫码有订单号/order/bindOrderForCustomer
export const bindOrderForCustomer = params => {
  return apiFulfillment.post('/order/bindOrderForCustomer', params)
}
// 确认页提交下单
export const shopCreateOrder = params => {
  return params.orderType === 'EW' ? apiEW.post('/occ/order/as/ew/client/v1/mobile/order/create', params) : apiFulfillment.post('/order/createOrder', params)
}

export const getShopListDealer = params => {
  return api.get('/basis/getDealersBySc', { params })
}

// 品类菜单
export const getCategoryList = params => {
  return apiFulfillment.get('/malllist/categoryList', { params })
}

// 滑动品类菜单
export const getTopCategoryList = params => {
  return apiFulfillment.get('/malllist/topCategoryList', { params })
}
// 获取商品列表
export const getProductList = params => {
  return apiEW.post('/occ/product/as/aggregator/client/v1/mall/product/list', params)
}

// 产品详情
export const getProductDetailBySpuId = params => {
  return apiFulfillment.get('/malllist/spuDetail', { params })
}

// sku-->可销售经销商列表-->dealerList
export const getShopDealerListBySku = params => {
  return apiFulfillment.get('/malllist/skuDealerList', { params })
}
// gscode-->经销商获取SKU价格-->skuList
export const getShopSkuListByGsCode = params => {
  return apiFulfillment.get('/malllist/skuListByGsCode', { params })
}
//gsCode+ sku--> 产品可使用范围
export const getShopApplyScopeDealerList = params => {
  return apiFulfillment.get('/malllist/applyScopeDealerList', { params })
}

// 延保产品详情
export const getEWShopDetailBySpuId = (spuId, params) => {
  return apiEW.post(`/occ/product/as/ew/client/v1/mall/product/${spuId}/detail`, params)
}

// EW spu可销售经销商
export const getEWShopDealerListBySpu = (spuId, params) => {
  return apiEW.post(`/occ/product/as/ew/client/v1/mall/dealer/${spuId}/sales-dealers`, params)
}

// EW sku 可使用经销商
export const getApplyDealerList = params => {
  return apiEW.post(`/occ/product/as/ew/client/v1/mall/dealer/${params.skuId}/apply-dealers`, params)
}

// OTR扫码进入：根据token获取参数
export const getShopInfoByqrInfoKey = params => {
  return apiFulfillment.get('/order/getQrCode', { params })
}

// CDO扫码进入：根据token获取参数
export const getCdoQrCodeInfoByqrInfoKey = params => {
  return apiFulfillment.get('/order/getCdoQrCode', { params })
}

// 预览详情
export const getPreviewDetailBySpuId = params => {
  return apiFulfillment.get('/malllist/previewSpuDetail', { params })
}

// EW 预览商品详情
export const getEWPreviewDetailBySpuId = id => {
  return apiEW.get(`/occ/product/as/ew/client/v1/mall/product/${id}/preview`)
}

// 获取code
export const getVerificationCode = params => {
  // return apiFulfillment.get('/malllist/topCategoryList', { params })
  return api.get('/customer/carInfo/getVerifyCode', { params })
}

// 校验code有效性
export const checkVerificationCode = params => {
  // return apiFulfillment.get('/malllist/topCategoryList', { params })
  return api.post('/customer/carInfo/checkVerifyCode', params)
}

//获取延保订单确认页信息
export const getEWOrderConfirmDetail = params => {
  return apiEW.post('/occ/product/as/ew/client/v1/mall/product/order-confirm-detail', params)
}

//延保OTR扫码进入获取信息
export const getEWOrderConfirmDetailByOTR = orderNo => {
  return apiEW.get(`/occ/order/as/ew/client/v1/mobile/product-order-detail?orderNo=${orderNo}`)
}

//延保OTR绑定订单
export const bindOTROrder = params => {
  return apiEW.post('/occ/order/as/ew/client/v1/mobile/go-buy', params)
}
